import { client } from "./client";
// eslint-disable-next-line object-shorthand
export const list = params => client.get("payments", { params: params });
export const loadList = params => client.get("payments", { params: params });
export const loadListSubscriptions = params => client.get("payments/subscriptions", { params: params });
// export const download = params => client.get('payments/export', { params: params });
export const get = id => client.get(`payments/${id}`);
// eslint-disable-next-line object-shorthand
export const exportPayments = params => client.post("payments/export", params);
export const downloadExport = params => client.get("payments/download_export", { params: params });
export const checkExportStatus = () => client.get("payments/check_export_status");
export const newPayment = params => client.post("payments", { payment: params });
export const updateSubscription = params =>
  client.post(`payments/subscription_update/${params["id"]}`, { subscription: params });
